const Images = {
    xpanseLogo: require('../assets/images/xpanseLogo.png'),
    xpanseSplashLogo: require('../assets/images/xpanseSplashLogo.png'),
    xpanseNavLogo: require('../assets/images/navLogo.png'),
    xpanseNewNavLogo: require('../assets/images/newNavLogo.png'),
    xpanseBottomNavLogo: require('../assets/images/xpanceBottomNavLogo.png'),
    xpanseBottomNavLogoActive: require('../assets/images/xpanceBottomNavLogoActive.png'),
    xpanseCartActive: require('../assets/images/xpanseCartActive.png'),
    xpanseCartUnActive: require('../assets/images/xpanseCartUnActive.png'),
    xpanseOfferActive: require('../assets/images/xpanseOfferActive.png'),
    xpanseOfferUnActive: require('../assets/images/xpanseOfferUnActive.png'),
    xpanseSubscriptionActive: require('../assets/images/xpanseSubscriptionActive.png'),
    xpanseSubscriptionUnActive: require('../assets/images/xpanseSubscriptionInactive.png'),
    xpanseMapMarker: require('../assets/images/xpanseMapMarker.png'),
    xpanseDeliveryPin: require('../assets/images/deliveryPin.png'),
    navProfile: require('../assets/images/navProfile.png'),
    maleAvatar: require('../assets/images/male.png'),
    femaleAvatar: require('../assets/images/female.png'),

    cloudR1: require('../assets/images/rc1.png'),
    cloudR2: require('../assets/images/rc2.png'),
    cloudL1: require('../assets/images/lc1.png'),
    cloudL2: require('../assets/images/lc2.png'),
    firstScreenDots: require('../assets/images/firstScreenDots.png'),
    secondScreenDots: require('../assets/images/secondScreenDots.png'),
    prevButton: require('../assets/images/prevButton.png'),
    nextButton: require('../assets/images/nextButton.png'),

    veg: require('../assets/images/veg.png'),
    nonVeg: require('../assets/images/nonVeg.png'),
    vegan: require('../assets/images/vegan.png'),
    successTick: require('../assets/images/successTick.png'),
    heartIcon: require('../assets/images/heartIcon.png'),
    shareIcon: require('../assets/images/shareIcon.png'),
    searchBarImage: require('../assets/images/searchBarImage.png'),
    closeSearch: require('../assets/images/closeSearch.png'),
    closeButton: require('../assets/images/closeButton.png'),
    heartFilled: require('../assets/images/heartFilled.png'),
    cafeImage: require('../assets/images/cafe_img.png'),
    upcomingCafe: require('../assets/images/upcoming-cafe.png'),
    product1: require('../assets/images/product1.png'),
    coupon: require('../assets/images/coupon.png'),
    star: require('../assets/images/starOutlined.svg'),
    welcomeCoupon: require('../assets/images/welcomeCoupon.png'),
    couponScreenCoupon: require('../assets/images/couponScreen.png'),
    categoryHead: require('../assets/images/categoryHead.jpg'),
    profileHead: require('../assets/images/profileHead.png'),
    membershipCard: require('../assets/images/membershipCard.png'),
    xpanseCup: require('../assets/images/xpanseCup.png'),
    xpanseCupPointActive: require('../assets/images/xpanseCupPointActive.png'),
    xpanseCupPointUnActive: require('../assets/images/xpanseCupPointInactive.png'),
    emptyCartImage: require('../assets/images/emptyCartBird.png'),
    customerSupport: require('../assets/images/customerSupport.png'),
    newTag: require('../assets/images/newTag.png'),
    birthdayModal: require('../assets/images/birthdayModal.png'),
    upcomingOutlet: require('../assets/images/upcomingOutlet.png'),
    addIcon: require('../assets/images/quickAdd.png'),
    newArrivalBanner: require('../assets/images/new-arrivals.webp'),

    gPayLogo: require('../assets/images/gPayLogo.png'),
    phonepeLogo: require('../assets/images/phonePeLogo.png'),
    upiLogo: require('../assets/images/upiLogo.png'),
    zomatoLogo: require('../assets/images/Zomato-logo.png'),

    orderDetailQrBox: require('../assets/images/orderDetailBox.png'),
    couponBorder: require('../assets/images/couponBorder.png'),
    couponBorderInverted: require('../assets/images/couponBorderInverted.png'),
    couponDiscountBg: require('../assets/images/couponDiscountBg.png'),
    couponDiscountBgInactive: require('../assets/images/couponDiscountBgInactive.png'),
    couponDiscountBgBirthday: require('../assets/images/couponDiscountBgBirthday.png'),
    circleDot: require('../assets/images/circleDot.png'),
    circleDotActive: require('../assets/images/circleDotActive.png'),

    adBanner: require('../assets/images/homeAd1.png'),
    homeCover: require('../assets/images/homeCover.png'),
    pickUpIcon: require('../assets/images/pickUpIcon.png'),
    deliveryOption: require('../assets/images/DeliveryOption.png'),
    pickupOption: require('../assets/images/pickupOption.png'),

    drinkSmall: require('../assets/images/drinkSmall.png'),
    drinkSmallSelected: require('../assets/images/drinkSmallSelected.png'),
    drinkMedium: require('../assets/images/drinkMedium.png'),
    drinkMediumSelected: require('../assets/images/drinkMediumSelected.png'),
    drinkLarge: require('../assets/images/drinkLarge.png'),
    drinkLargeSelected: require('../assets/images/drinkLargeSelected.png'),

    coupon1: require('../assets/images/coupon1.png'),
    coupon2: require('../assets/images/coupon2.png'),
    couponSavedBird: require('../assets/images/couponSavedBird.png'),    
    couponDDiscount: require('../assets/images/couponDDiscount.png'),    
    sizeUpModal: require('../assets/images/sizeUpModal.png'),
    freebieCoupon: require('../assets/images/freebieImage.png'),
    scratchCard: require('../assets/images/scratchCard.png'),
    unlockJourney: require('../assets/images/inActive-journeyCoupon.png'),

    subscriptionBanner: require('../assets/images/subscriptionBanner.png'),
    subPlan: require('../assets/images/subPlan.png'),
    subDetailBanner: require('../assets/images/subDetailBanner.png'),
    activePlanBird: require('../assets/images/activePlanBird.png'),
    subLimit: require('../assets/images/subLimit.png'),
    subSearchBird: require('../assets/images/subSearchBird.png'),

    // Animations
    successGif: require('../assets/animations/successTick.json'),
    emptyCart: require('../assets/animations/emptyCart.json'),
    micAnimation: require('../assets/animations/micAnimation.json'),
    noResult: require('../assets/animations/noResult.json'),
    applyingCouponAnimation: require('../assets/animations/applyingCouponAnimation.json'),
    paymentLoader: require('../assets/animations/paymentLoader.gif'),
    timeLoading: require('../assets/animations/timeLoading.json'),
    snowFall: require('../assets/animations/snowFall.gif'),
    glowingBg: require('../assets/animations/glowingBg.json'),
    conffetti: require('../assets/animations/confetti.json'),

    //Franchise page
    cafeCloud: require('../assets/images/franchisePage/cafe_oncloud1.png'),
    cafeMobile: require('../assets/images/franchisePage/cafe_F1.png'),
    bulletPoint: require('../assets/images/franchisePage/not-point.png'),
    cloud1: require('../assets/images/franchisePage/cloud_1.png'),
    cloud2: require('../assets/images/franchisePage/cloud_2.png'),
    cloud3: require('../assets/images/franchisePage/cloud_3.png'),
    cloud4: require('../assets/images/franchisePage/cloud_4.png'),
    cloud5: require('../assets/images/franchisePage/cloud_5.png'),
    vision: require('../assets/images/franchisePage/vision.png'),
    visionMob: require('../assets/images/franchisePage/vision-mob.png'),
    p1_1: require("../assets/images/franchisePage/1-1.png"),
    p1_2: require("../assets/images/franchisePage/1-2.png"),
    p1_3: require("../assets/images/franchisePage/1-3.png"),
    p1_4: require("../assets/images/franchisePage/1-4.png"),
    p2_1: require("../assets/images/franchisePage/p2-1.png"),
    p2_2: require("../assets/images/franchisePage/p2-2.png"),
    p2_3: require("../assets/images/franchisePage/p2-3.png"),
    p2_4: require("../assets/images/franchisePage/p2-4.png"),
    a1_1: require("../assets/images/franchisePage/a1-1.png"),
    a1_2: require("../assets/images/franchisePage/a1-2.png"),
    a1_3: require("../assets/images/franchisePage/a1-3.png"),
    a1_4: require("../assets/images/franchisePage/a1-4.png"),
    a1: require("../assets/images/franchisePage/a1.png"),
    a2: require("../assets/images/franchisePage/a2.png"),
    a3: require("../assets/images/franchisePage/a3.png"),
    a4: require("../assets/images/franchisePage/a4.png"),
    a2_1: require("../assets/images/franchisePage/a2-1.png"),
    a2_2: require("../assets/images/franchisePage/a2-2.png"),
    a2_3: require("../assets/images/franchisePage/a2-3.png"),
    a2_4: require("../assets/images/franchisePage/a2-4.png"),
    a3_1: require("../assets/images/franchisePage/a3-1.png"),
    a3_2: require("../assets/images/franchisePage/a3-2.png"),
    a3_3: require("../assets/images/franchisePage/a3-3.png"),
    a3_4: require("../assets/images/franchisePage/a3-4.png"),
    a4_1: require("../assets/images/franchisePage/a4-1.png"),
    a4_2: require("../assets/images/franchisePage/a4-2.png"),
    a4_3: require("../assets/images/franchisePage/a4-3.png"),
    a4_4: require("../assets/images/franchisePage/a4-4.png"),
    shakio: require("../assets/images/shakio.gif"),

    toGoCafe: require('../assets/images/franchisePage/to-goCafe.png'),
    qwikCafe: require('../assets/images/franchisePage/qwikCafe.png'),
    flagshipCafe: require('../assets/images/franchisePage/flagshipCafe.png'),
}

export default Images;
